const getAttachemntType = (type = '') => {
  switch (type) {
    case 1: {
      return 'pdf';
    }
    case 2: {
      return 'video';
    }
    case 3: {
      return 'image';
    }
    default: {
      throw new Error(`Type "${type}" not recognized`);
    }
  }
};

export default getAttachemntType;
